// @flow

import React from "react";
import { localize } from "redux-i18n";
import { WistiaPlayer, SimpleGrid } from "@components";

type Props = PropsFromLocalize;

class HelpPanelUserEmployees extends React.Component<Props> {
  get searchOptionsData() {
    return [
      {
        id: "surname",
        label: this.props.t("SURNAME"),
        details: this.props.t("SEARCH_SURNAME_DESCRIPTION"),
      },
      {
        id: "date-of-birth",
        label: this.props.t("DATE_OF_BIRTH"),
        details: this.props.t("SEARCH_DATE_OF_BIRTH_DESCRIPTION"),
      },
      {
        id: "ref",
        label: this.props.t("EMPLOYEE_REF"),
        align: "left",
        details: this.props.t("SEARCH_EMPLOYEE_REF_DESCRIPTION"),
      },
      {
        id: "department",
        label: this.props.t("DEPARTMENT"),
        details: this.props.t("SEARCH_DEPARTMENT_DESCRIPTION"),
      },
      {
        id: "user-id",
        label: this.props.t("USER_ID"),
        details: this.props.t("SEARCH_USER_ID_DESCRIPTION"),
      },
      {
        id: "status",
        label: this.props.t("STATUS"),
        details: this.props.t("SEARCH_STATUS_DESCRIPTION"),
      },
      {
        id: "absence-id",
        label: this.props.t("ABSENCE_ID"),
        details: this.props.t("SEARCH_ABSENCE_ID_DESCRIPTION"),
      },
      {
        id: "email",
        label: this.props.t("EMAIL_ADDRESS"),
        details: this.props.t("SEARCH_EMAIL_ADDRESS_DESCRIPTION"),
      },
      {
        id: "phone",
        label: this.props.t("PHONE_NUMBER"),
        details: this.props.t("SEARCH_PHONE_NUMBER_DESCRIPTION"),
      },
    ];
  }

  get dataSecurityData() {
    return [
      {
        id: "security-notice",
        label: this.props.t("DATA_SECURITY_NOTICE"),
        details: this.props.t("DATA_SECURITY_NOTICE_DESCRIPTION"),
      },
      {
        id: "audit-logs",
        label: this.props.t("AUDIT_LOGS"),
        details: this.props.t("DATA_SECURITY_LOGS_DESCRIPTION"),
      },
    ];
  }

  get recordContentData() {
    return [
      {
        id: "details",
        label: this.props.t("DETAILS"),
        details: this.props.t("RECORD_DETAILS_DESCRIPTION"),
      },
      {
        id: "absences",
        label: this.props.t("ABSENCES"),
        details: this.props.t("RECORD_ABSENCES_DESCRIPTION"),
      },
      {
        id: "statistics",
        label: this.props.t("STATISTICS"),
        details: this.props.t("RECORD_STATISTICS_DESCRIPTION"),
      },
      {
        id: "notes",
        label: this.props.t("NOTES"),
        details: this.props.t("RECORD_NOTES_DESCRIPTION"),
      },
      {
        id: "documents",
        label: this.props.t("DOCUMENTS"),
        details: this.props.t("RECORD_DOCUMENTS_DESCRIPTION"),
      },
      {
        id: "notifications",
        label: this.props.t("NOTIFICATIONS"),
        details: this.props.t("RECORD_NOTIFICATIONS_DESCRIPTION"),
      },
      {
        id: "monitoring",
        label: this.props.t("MONITORING"),
        details: this.props.t("RECORD_MONITORING_DESCRIPTION"),
      },
      {
        id: "referrals",
        label: this.props.t("REFERRALS"),
        details: this.props.t("RECORD_REFERRALS_DESCRIPTION"),
      },
      {
        id: "account",
        label: this.props.t("ACCOUNT"),
        details: this.props.t("RECORD_ACCOUNT_DESCRIPTION"),
      },
      {
        id: "export",
        label: this.props.t("EXPORT"),
        details: this.props.t("RECORD_EXPORT_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("EMPLOYEES_HELP_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.EMPLOYEES_INSTRUCTIONS}
            title={this.props.t("EMPLOYEES_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("SEARCH_OPTIONS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.searchOptionsData} />
        <h6 className="font-weight-bold">{this.props.t("DATA_SECURITY")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.dataSecurityData} />
        <h6 className="font-weight-bold">{this.props.t("RECORD_CONTENTS")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.recordContentData} />
      </div>
    );
  }
}

export default localize()(HelpPanelUserEmployees);
